import { useEffect, useState } from 'react'

import { IconCloseSm } from 'assets/svg/sprite'
import { getStoryBackground } from 'components/UI/BackgroundPicker/BackgroundPicker'
import { type IGoal } from 'types/interfaces/ITypes'

import { GoalBox } from './GoalBox'
import './_goalPreview.scss'

interface Props {
  goalData: IGoal
  clearGoalData: () => void
}

const OPTIONS = [5, 10, 15]

export const GoalPreview = ({ goalData, clearGoalData }: Props) => {
  const [filePreviewUrl, setFilePreviewUrl] = useState<string | null>(null)

  useEffect(() => {
    const file = goalData.goalBgImg

    if (!(file instanceof File)) {
      setFilePreviewUrl(null)
      return
    }

    const url = URL.createObjectURL(file)
    setFilePreviewUrl(url)

    return () => {
      URL.revokeObjectURL(url)
    }
  }, [goalData.goalBgImg])

  const imageUrl =
    typeof goalData.goalBgImg === 'string'
      ? goalData.goalBgImg
      : goalData.goalBgImg instanceof File
        ? filePreviewUrl
        : null

  const resolvedBackground = getStoryBackground(goalData.goalBg)

  const backgroundImage = imageUrl
    ? `url("${imageUrl}")`
    : resolvedBackground

  const isSolidColor =
    !imageUrl &&
    typeof resolvedBackground === 'string' &&
    !resolvedBackground.includes('gradient(') &&
    !resolvedBackground.startsWith('url(')

  return (
    <div className='goalPreview'>
      <div
        className='goalPreview__wrapper'
        style={{
          backgroundImage: isSolidColor ? 'none' : backgroundImage,
          backgroundColor: isSolidColor ? resolvedBackground : undefined
        }}
      >
        <div className='goalPreview__close' onClick={clearGoalData}>
          <IconCloseSm color='#0D1444' />
        </div>
        <GoalBox
          title={goalData.title}
          goal={goalData.amount}
          tipped='0'
          options={OPTIONS}
          disabled
          isMyPost={true}
        />
      </div>
    </div>
  )
}